export default {
    export: 'Exportação',
    'credits-buy': 'Compra de créditos',
};
